/* unplugin-vue-components disabled */import { render } from "./Identity.vue?vue&type=template&id=3538df44&ts=true"
import script from "./Identity.vue?vue&type=script&lang=ts"
export * from "./Identity.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/liyankai6/Documents/project/print-open/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__